export default {
      id: "ic-nav-search-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-nav-search-usage",
      toString: function () {
        return this.url;
      }
    }